import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import NewsletterForm from "./NewsletterForm";
import { PHONE_NUMBER, EMAIL, GOOGLE_REVIEWS_URL } from "../lib/api";

const GoogleG = () => <span className="text-sm font-bold leading-none">G</span>;
const SOCIALS = [
  { Icon: Facebook, href: "https://www.facebook.com/acchajeetravels/", label: "Facebook" },
  { Icon: Instagram, href: "https://www.instagram.com/acchajeetravels/", label: "Instagram" },
  { Icon: GoogleG, href: GOOGLE_REVIEWS_URL, label: "Google Business Profile" },
];

const DEST = ["Dubai", "Singapore", "Thailand", "Bali", "Maldives", "Kashmir", "Kerala", "Goa"];
const VISA = ["Singapore", "Dubai", "USA", "UK", "Schengen", "Japan"];

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] text-white pt-20 pb-8 mt-20" data-testid="site-footer">
      <div className="container-p grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="mb-4">
            <div className="inline-block bg-white rounded-xl px-3 py-2">
              <img src="/logo.png" alt="Acchajee Travels" className="h-12 w-auto" data-testid="footer-logo" />
            </div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-white/60 mt-3">Explore. Experience. Elevate.</div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed max-w-md mb-6">India's trusted travel partner for domestic & international holiday packages, visa assistance, cruises, honeymoons and corporate travel — since 2012.</p>
          <NewsletterForm />
        </div>
        <div>
          <h4 className="font-display font-semibold mb-4 text-white">Popular Destinations</h4>
          <ul className="space-y-2 text-sm text-white/70">
            {DEST.map((d) => <li key={d}><Link to={`/packages?destination=${d}`} className="hover:text-[#FF7D00]" data-testid={`footer-dest-${d.toLowerCase()}`}>{d}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-4 text-white">Visa Services</h4>
          <ul className="space-y-2 text-sm text-white/70">
            {VISA.map((v) => <li key={v}><Link to={`/visa/${v.toLowerCase().replace(/\s+/g,'-')}`} className="hover:text-[#FF7D00]">{v}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-4 text-white">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#FF7D00] flex-shrink-0" /> Mile Stone, 1/2, Khandsa Rd, near Sector 10 A Market, opposite Canara Bank Back Side, Pace City I, Sector 37, Gurugram, Haryana 122004</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#FF7D00]" /> <a href={`tel:${PHONE_NUMBER}`} className="hover:text-[#FF7D00]">{PHONE_NUMBER}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#FF7D00]" /> <a href={`mailto:${EMAIL}`} className="hover:text-[#FF7D00]">{EMAIL}</a></li>
          </ul>
          <div className="flex gap-3 mt-5">
            {SOCIALS.map(({ Icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} title={label} className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#FF7D00] flex items-center justify-center transition" data-testid={`footer-social-${label.split(" ")[0].toLowerCase()}`}><Icon className="w-4 h-4" /></a>
            ))}
          </div>
        </div>
      </div>
      <div className="container-p mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
        <p>© {new Date().getFullYear()} Acchajee Travels. All rights reserved. IATA Approved.</p>
        <div className="flex gap-5"><a href="#" className="hover:text-white">Privacy</a><a href="#" className="hover:text-white">Terms</a><Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link></div>
      </div>
    </footer>
  );
}
